import { useMemo } from 'react'

import { TCartItem, useCart } from '@/entities/cart'

import { ProductType } from '@/shared/types/deprecated-types'

export type UseAppliedAccessoriesReturn = {
	appliedAccessories: TCartItem[]
	hasAppliedAccessories: boolean
}

/**
 * Хук для получения примененных аксессуаров к конкретному товару в корзине
 * @param productId - ID товара в корзине
 * @returns объект с массивом примененных аксессуаров и флагом наличия
 */
export const useAppliedAccessories = (productId: number): UseAppliedAccessoriesReturn => {
	const { products } = useCart()

	const appliedAccessories = useMemo(() => {
		if (!products?.length) return []

		return products.filter(item => item.TYPE_PRODUCTS === ProductType.Accessory && item.RELATED_PRODUCTS === productId)
	}, [products, productId])

	return {
		appliedAccessories,
		hasAppliedAccessories: appliedAccessories.length > 0
	}
}
